import { IWithSummaryModel } from "src/app/modules/common/permission/api/entity/iWithSummary.model";
import { MedicalSterilizationSummaryModel } from "./medicalSterilizationSummary.model";
import {MedicalDeviceSummaryModel} from "../../../../device/account/api/entity/medicalDeviceSummary.model";
import {MedicalToolSetSummaryModel} from "../../../toolset/api/entity/medicalToolSetSummary.model";
import {DocumentSummaryModel} from "../../../../../document/common/api/model/documentSummary.model";

export class MedicalSterilizationModel implements IWithSummaryModel<MedicalSterilizationSummaryModel> {
  summary: MedicalSterilizationSummaryModel;
  medicalDevice: MedicalDeviceSummaryModel;
  instrumentSets: MedicalToolSetSummaryModel[] = [];
  picture: DocumentSummaryModel;
  comment: string;
}

